import { sendAppSignal } from 'hooks/app-signal'

export const showAnnouncements = () => global.setTimeout(() => sendAppSignal('announcements.show'), 500)
export const showFeatureRoadmap = () => global.setTimeout(() => sendAppSignal('feature-roadmap.show'), 500)
export const showValue = (options = {}) => () => global.setTimeout(() => sendAppSignal('value.show', options), 500)
export const showQuickGuide = which => () => global.setTimeout(() => sendAppSignal('quick-guide.show', which), 500)